import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { usePlayerIdentity } from '../contexts/PlayerContext';
import casinoWS from '../services/websocket';

export default function AchievementToasts() {
  const { t } = useTranslation();
  const [achievementToasts, setAchievementToasts] = useState([]);
  const toastTimeoutsRef = useRef([]);
  const { steamIdRef } = usePlayerIdentity();

  useEffect(() => {
    const unsub = casinoWS.on('achievementsUnlocked', (data) => {
      if (data.steamId && data.steamId !== steamIdRef.current) return;

      if (data.unlocked && data.unlocked.length > 0) {
        data.unlocked.forEach((achievement, index) => {
          const outerTimeout = setTimeout(() => {
            const toastId = `achievement-${Date.now()}-${achievement.id}`;

            setAchievementToasts(prev => {
              if (prev.some(t => t.achievementId === achievement.id)) return prev;
              return [...prev, {
                id: toastId,
                achievementId: achievement.id,
                name: achievement.name,
                description: achievement.description,
                reward: achievement.reward,
              }];
            });

            const innerTimeout = setTimeout(() => {
              setAchievementToasts(prev => prev.filter(t => t.id !== toastId));
            }, 5000);

            toastTimeoutsRef.current.push(innerTimeout);
          }, index * 800);

          toastTimeoutsRef.current.push(outerTimeout);
        });
      }
    });

    return () => {
      unsub();
      toastTimeoutsRef.current.forEach(clearTimeout);
      toastTimeoutsRef.current = [];
    };
  }, [steamIdRef]);

  if (achievementToasts.length === 0) return null;

  return (
    <div className="achievement-toasts">
      {achievementToasts.map(toast => (
        <div key={toast.id} className="achievement-toast">
          <div className="achievement-toast-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/><path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
              <path d="M4 22h16"/><path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/>
              <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/>
              <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"/>
            </svg>
          </div>
          <div className="achievement-toast-content">
            <span className="achievement-toast-title">{t('achievement_unlocked')}</span>
            <span className="achievement-toast-name">{toast.name}</span>
            <span className="achievement-toast-reward">{t('achievement_reward_points', { reward: toast.reward })}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
